import { useEffect, useState, useCallback } from 'react'
import { sendEvents } from '../../../../analytics/eventWrapper'
import { CLEVERTAP_EVENTS } from '../../../../analytics/trackerEvents/cleverTap/events'
import { CT_PARAMS } from '../../../../analytics/trackerEvents/cleverTap/parameters'
import { TOGGLE_VIBRATION } from '../../../../analytics/soundEvents/events'
import { parseJSON } from '../../../../utils/helpers/common'
import { readUserSetting, toggelUserSetting } from '../../../../classes/sound'
import { DEFAULTS_USER_SETTING, USER_SETTING_KEYS } from '../../../../classes/sound/constants'

const FULFILLED = 'fulfilled'

const useSettingsBottomsheet = () => {
  const [soundStatus, setSoundStatus] = useState(false)

  const [musicStatus, setMusicStatus] = useState(false)
  const [vibrationStatus, setVibrationStatus] = useState(false)

  useEffect(() => {
    const init = async () => {
      try {
        const [musicResult, soundResult, vibrationResult] = await Promise.allSettled([
          readUserSetting(USER_SETTING_KEYS.MUSIC),
          readUserSetting(USER_SETTING_KEYS.SOUND),
          readUserSetting(USER_SETTING_KEYS.VIBRATION)
        ])

        //{"musicResult": {"status": "fulfilled", "value": false}, "soundResult": {"status": "fulfilled", "value": true}, "vibrationResult": {"status": "fulfilled", "value": false}}
        setMusicStatus(
          musicResult?.status === FULFILLED ? musicResult?.value : parseJSON(DEFAULTS_USER_SETTING[USER_SETTING_KEYS.MUSIC])
        )
        setSoundStatus(
          soundResult?.status === FULFILLED ? soundResult?.value : parseJSON(DEFAULTS_USER_SETTING[USER_SETTING_KEYS.SOUND])
        )
        setVibrationStatus(
          vibrationResult?.status === FULFILLED
            ? vibrationResult?.value
            : parseJSON(DEFAULTS_USER_SETTING[USER_SETTING_KEYS.VIBRATION])
        )
      } catch (error) {
        // logger(TAG_NAMES.LS_GAMEPLAY, 'Error in promise while initializing sound, music or vibration', {
        //   isBreadcrumb: true,
        //   isAddEvent: true,
        //   error
        // })
      }
    }
    init()
  }, [])

  const handleMusicToggle = async () => {
    const value = await toggelUserSetting(USER_SETTING_KEYS.MUSIC)
    setMusicStatus(value)
    // logger(TAG_NAMES.LS_GAMEPLAY, `Music toggled - ${value}`, {
    //   isBreadcrumb: true,
    //   isLogToFile: false
    // })
    sendEvents({
      name: CLEVERTAP_EVENTS.EVENT_GAME_MUSIC_TOGGLE,
      params: {
        [CT_PARAMS.NEW_VALUE]: value
      }
    })
  }
  const handleSoundToggle = async () => {
    const playSoundStatusFlag = await toggelUserSetting(USER_SETTING_KEYS.SOUND)
    setSoundStatus(playSoundStatusFlag)
    // logger(TAG_NAMES.LS_GAMEPLAY, `Sound toggled - ${playSoundStatusFlag}`, {
    //   isBreadcrumb: true,
    //   isLogToFile: false
    // })
    sendEvents({
      name: CLEVERTAP_EVENTS.EVENT_GAME_SOUND_TOGGLE,
      params: {
        [CT_PARAMS.NEW_VALUE]: playSoundStatusFlag
      }
    })
  }

  const handleVibrationToggle = useCallback(async () => {
    const vibration = await toggelUserSetting(USER_SETTING_KEYS.VIBRATION)
    setVibrationStatus(vibration)
    // logger(TAG_NAMES.LS_GAMEPLAY, `Sound toggled - ${vibration}`, {
    //   isBreadcrumb: true,
    //   isLogToFile: false
    // })
    sendEvents([
      { name: TOGGLE_VIBRATION },
      {
        name: CLEVERTAP_EVENTS.EVENT_GAME_VIBRATION_TOGGLE,
        params: {
          [CT_PARAMS.NEW_VALUE]: vibration
        }
      }
    ])
  }, [])

  return {
    soundStatus,
    musicStatus,
    vibrationStatus,
    handleMusicToggle,
    handleSoundToggle,
    handleVibrationToggle
  }
}

export default useSettingsBottomsheet
